// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  enableDebug: true,

  numero_WhatsApp: "+393533385974",
  numero_telefono: "tel:+393533385974",

  //text per personalizzare i messaggi
  canShowPagamentoRate: false,
  textShowPagamentoRate: "in comode <strong>2 rate</strong>",

  canShowElencoDate: true,

  /*
  urlWeb: 'http://localhost/',
  // Path BASE del materiale: il segmento {id_partner}/ va appeso lato template
  // perche' i file sono caricati per partner (vedi pages/dropzone-materiale.php).
  // Prima era hardcoded "/1/" -> rotto per corsisti di sotto-partner.
  urlMaterialeDidattico: 'http://localhost/assets/media/materiale-didattico/',
  urlImageCorso: 'http://localhost/assets/media/corso/',
  urlImageCorsoHD: 'http://localhost/assets/media/corso/hd/',
  urlImageVideoCorso: 'http://localhost/assets/media/corso/video/',
  web_api_url_base: 'http://localhost/api/',

  urlStampa: 'http://localhost/stampe/',

  urlAttestati: 'http://localhost/assets/media/certificate/corsisti/',
  urlAttestatiDaCreare: 'http://localhost/pages/certificate/',
  urlImagePartners: 'http://localhost/assets/media/partners/',
  urlImageMedia: 'http://localhost/assets/media/',
  */

  urlWeb: 'https://spformazionecampania.discentya.it/',
  urlMaterialeDidattico: 'https://spformazionecampania.discentya.it/assets/media/materiale-didattico/',
  urlImageCorso: 'https://spformazionecampania.discentya.it/assets/media/corso/',
  urlImageCorsoHD: 'https://spformazionecampania.discentya.it/assets/media/corso/hd/',
  urlImageVideoCorso: 'https://spformazionecampania.discentya.it/assets/media/corso/video/',
  web_api_url_base: 'https://spformazionecampania.discentya.it/api/',

  urlStampa: 'https://spformazionecampania.discentya.it/stampe/',

  urlAttestati: 'https://spformazionecampania.discentya.it/assets/media/certificate/corsisti/',
  urlAttestatiDaCreare: 'https://spformazionecampania.discentya.it/pages/certificate/',
  urlImagePartners: 'https://spformazionecampania.discentya.it/assets/media/partners/',
  urlImageMedia: 'http://spformazionecampania.discentya.it/assets/media/',

};

